module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container masonry-youtube",
    attrs: {
      "id": "masonry-youtube"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered"
  }, [_c('div', {
    staticClass: "column is-10"
  }, [(false) ? _c('h1', {
    staticClass: "title"
  }, [_vm._v("\n        Videos\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "masonry",
      rawName: "v-masonry"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "masonry-container",
    attrs: {
      "id": "masonry-container",
      "transition-duration": "0.0s",
      "item-selector": ".masonry-item",
      "data-masonry-options": "{ 'isFitWidth': true }",
      "infinite-scroll-disabled": "itemsLoading",
      "infinite-scroll-distance": "10"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      directives: [{
        name: "masonry-tile",
        rawName: "v-masonry-tile"
      }],
      staticClass: "masonry-item",
      attrs: {
        "data-aos": "slide-up",
        "data-aos-once": "true",
        "data-aos-duration": "1000",
        "data-aos-offset": "0"
      }
    }, [_c('a', {
      attrs: {
        "href": 'http://www.youtube.com/watch?v=' + item.snippet.resourceId.videoId,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-image"
    }, [_c('figure', {
      staticClass: "image",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.parseInstagramImageLink(item.snippet.thumbnails.high.url),
        "alt": "Image"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-image-cover"
    }, [_c('i', {
      staticClass: "fa fa-4x fa-play"
    }), _vm._v(" "), _c('div', {
      staticClass: "card-image-cover-description"
    }, [_vm._v("\n                      " + _vm._s(item.snippet.title) + "\n                    ")])])])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "load-more"
  }, [(!_vm.itemsEnded) ? _c('div', {
    staticClass: "button",
    class: {
      'is-loading': _vm.itemsLoading
    },
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.itemsEnded) ? _c('div', {
    staticClass: "ended",
    attrs: {
      "data-aos": "slide-up",
      "data-aos-once": "true",
      "data-aos-duration": "1000"
    }
  }, [_vm._v("More videos:"), _c('br', {
    staticClass: "is-hidden-desktop"
  }), _vm._v("  "), _c('a', {
    attrs: {
      "href": _vm.navYoutube.path,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-youtube",
    staticStyle: {
      "vertical-align": "middle"
    }
  }), _vm._v(" / " + _vm._s(_vm.navYoutube.title))])]) : _vm._e()]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88df8b82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MasonryYoutube.vue
// module id = 921
// module chunks = 1